import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoginService from '../login-service';
import texts from '../../texts/login';
import RegisterEditableInputs2 from './RegisterEditableInputs2';
import Conditions2 from './Conditions2';
import RegistrationService from './registration-service';
import { pinTroubleShooterUrl } from '../../config/url';
import { toast, ToastContainer } from 'react-toastify';
import logo1881 from "../../style/img/1881-logo-screen-secondary-RGB.svg";

class Register2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lookup: {},
      conditionsMode: false,
      submitted: false,
      lookUpExist: false,
      gotData: false,
      pin_error: false,
      terms_agreed: true,
      consent_allow_to_login: true,
      submitClicked: false,
      isFormInvalid: true,
    };
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
    // Add no-promo class to container since we don't have promotional content
    const container = document.querySelector('.login-promo-container');
    if (container) {
      container.classList.add('no-promo');
    }
  }

  componentDidUpdate() {
    const conditionsLink = document.querySelector('.conditions');
    if (conditionsLink) {
      conditionsLink.removeEventListener('click', this.openConditions.bind(this));
      conditionsLink.addEventListener('click', this.openConditions.bind(this));
    }
  }

  closeConditions() {
    this.setState({ conditionsMode: false });
  }

  openConditions(event) {
    event.preventDefault();
    this.setState({ conditionsMode: true });
  }

  loadData() {
    return LoginService.lookUp(this.props.cellphone).then(lookup => {
      const { firstName = '', lastName = '', streetAddress = '', zipcode = '', city = '' } = lookup;
      const lookUpExist = firstName !== '' && lastName !== '' && streetAddress !== '' && zipcode !== '' && city !== '';
      this.setState({ firstName, lastName, streetAddress, zipcode, city, lookUpExist, gotData: true });
    });
  }

  submit(event) {
    if (this.registerEditableInputs.isInValid() || this.state.terms_agreed === false || this.state.consent_allow_to_login === false) {
      event.preventDefault();
    }
  }

  renderConditions() {
    return <Conditions2 closeConditions={this.closeConditions.bind(this)} conditionsMode={this.state.conditionsMode} />;
  }

  getContinueWithoutRegistrationLink() {
    if (
      this.state.firstName &&
      this.state.lastName &&
      this.state.streetAddress &&
      this.state.zipcode
    ) {
      return RegistrationService.appendRequestParameters(this.props.redirectURI, [
        { key: 'firstName', value: this.state.firstName },
        { key: 'lastName', value: this.state.lastName },
        { key: 'streetAddress', value: this.state.streetAddress },
        { key: 'zipcode', value: this.state.zipcode },
        { key: 'city', value: this.state.city }
      ]);
    } else {
      return this.props.redirectURI;
    }
  }

  continueWithoutRegistration() {
    if (window.opener) {
      const { firstName, lastName, streetAddress, zipcode, city } = this.state;
      setInterval(function() {
        window.opener.postMessage(
          { firstName, lastName, streetAddress, zipcode, city },
          '*'
        );
      }, 1000);
    }
  }

  getTroubleShooterLink() {
    if (this.props.cellphone) {
      return RegistrationService.appendRequestParameters(pinTroubleShooterUrl, [
        { key: 'cellphone', value: this.props.cellphone },
        { key: 'type', value: 'pin' }
      ]);
    } else {
      return pinTroubleShooterUrl;
    }
  }

  renderPinTroubleShooting() {
    return (
      <div className="center">
        <div className="spacer-bottom-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="primary"
            onClick={this.continueWithoutRegistration.bind(this)}
            href={this.getTroubleShooterLink()}
          >
            {texts['register-user.pin-troubleshooter']}
          </a>
        </div>
      </div>
    );
  }

  renderSendingPinAgain() {
    return (
      <div>
        <div className="spacer-bottom-2">
          <a className="primary" href="" onClick={this.sendPinAgain.bind(this)}>
            {texts['register-user.pin-send-again']}
          </a>
        </div>
      </div>
    );
  }

  sendPinAgain(event) {
    event.preventDefault();
    return LoginService.getPin(this.props.cellphone).then(result => {
      if (result === false) {
        toast.error('Send pin mislyktes.');
        this.setState({ pin_error: true });
      } else {
        toast.success('Pin sendt');
        this.setState({ pin_error: false });
      }
    });
  }

  renderSendingPinFailure() {
    if (this.state.pin_error === true) {
      return (
        <div className="spacer-bottom-1">
          <p
            className="help-text"
            style={{ marginTop: '-10px', fontSize: '0.7rem' }}
            dangerouslySetInnerHTML={{
              __html: texts['register.pin-send-failure-report']
            }}
          />
        </div>
      );
    }
  }

  onInputChange(value) {
    this.setState(value);
    this.isFormInValid();
  }

  isFormInValid() {
    return (this.registerEditableInputs && this.registerEditableInputs.isInValid());
  }

  activeConsent(e) {
    this.setState({
      terms_agreed: e.target.checked,
    });
  }

  activeTraqConsent(e) {
    this.setState({
      consent_allow_to_login: e.target.checked,
    });
  }

  renderBottom() {
    return (
      <div className="primary">
        <div className="spacer-bottom-1">
          <span
            className="help-text"
            dangerouslySetInnerHTML={{
              __html: texts['existing-user.info']
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="register">
        <div className="login-container">
          <div className="login-promo-container no-promo">
            <div className="login-form-wrapper register-form">
              <img src={logo1881} alt="Opplysningen 1881" className="login-image" />
              <h1 className="headline">Registrering</h1>
              <form
                method="post"
                action="signup_oid"
                onSubmit={this.submit.bind(this)}
                acceptCharset="UTF-8"
                noValidate
              >
                <input name="CSRFtoken" type="hidden" value={this.props.CSRFtoken} />
                <input type="hidden" name="redirectURI" value={this.props.redirectURI} />
                <input type="hidden" name="cellphone" value={this.props.cellphone} />
                <input type="hidden" name="hashContent" value={this.props.hashContent} />
                <input type="hidden" name="UserCheckout" value={this.props.UserCheckout} />
                <input type="hidden" name="SessionCheck" value={this.props.SessionCheck} />
                <input type="hidden" name="targetApplicationId" value={this.props.targetApplicationId} />

                <RegisterEditableInputs2
                  ref={c => {
                    this.registerEditableInputs = c;
                  }}
                  firstName={this.state.firstName || ''}
                  lastName={this.state.lastName || ''}
                  streetAddress={this.state.streetAddress || ''}
                  zipcode={this.state.zipcode || ''}
                  city={this.state.city || ''}
                  cellphone={this.props.cellphone || ''}
                  email={this.state.email || ''}
                  pin={this.state.pin || ''}
                  submitted={this.state.submitted}
                  edit={this.state.gotData && !this.state.lookUpExist}
                  onInputChange={this.onInputChange.bind(this)}
                />

                <button
                  type="submit"
                  name="commit"
                  onMouseDownCapture={evt => {
                    evt.preventDefault();
                    if (this.isFormInValid()) {
                      this.setState({ submitted: false });
                    } else {
                      this.setState({ submitted: true });
                    }
                    this.setState({
                      submitClicked: true,
                    });
                  }}
                  className="btnSubmit"
                  id="submit"
                >
                  {texts['register.submit']}
                </button>
              </form>

              {this.renderSendingPinAgain()}
              {this.renderSendingPinFailure()}
              {this.renderBottom()}
            </div>
          </div>
        </div>

        {this.renderConditions()}

        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={true}
        />
      </div>
    );
  }
}

Register2.propTypes = {
  cellphone: PropTypes.string.isRequired,
  CSRFtoken: PropTypes.string.isRequired,
  redirectURI: PropTypes.string.isRequired,
  hashContent: PropTypes.string.isRequired,
  UserCheckout: PropTypes.string.isRequired,
  SessionCheck: PropTypes.string.isRequired,
  targetApplicationId: PropTypes.string
};

Register2.defaultProps = {
  targetApplicationId: ''
};

export default Register2;
